import(/* webpackMode: "eager" */ "/var/www/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/var/www/app/src/components/common/header.js");
